import React from 'react';
import { Stack } from '@mui/material';
import SystemGeneralInfoPanel from '../../components/SystemGeneralInfoPanel';
import SystemIntelPanel from '../../components/SystemIntelPanel';
import { useAuth } from '../../services/AuthContext';
import { useSystemIntel } from './SystemPage';

/** The at-a-glance landing tab: the full intel body over the intel its
 * parent already fetched, plus General Information — corp-wide notes and
 * linked fittings — for the account's own systems (both need
 * requireMember() routes, same gate corp activity already uses). */
const SystemOverview: React.FC = () => {
  const intel = useSystemIntel();
  const { me } = useAuth();
  return (
    <Stack spacing={3}>
      <SystemIntelPanel intel={intel} showCorpActivity={me.isMember} />
      {me.isMember && <SystemGeneralInfoPanel solarSystemId={intel.system.solar_system_id} />}
    </Stack>
  );
};

export default SystemOverview;
